import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStepTwo, TError } from './types/step-two-inerface';

const initialState: IStepTwo = {
    projectId: '',
    sellerId: '',
    regionId: '',
    productId: '',
    clientId: '',
    PolicyholderIsSame: true,
    Fio: '',
    LastName: '',
    FirstName: '',
    MiddleName: '',
    BirthDate: '',
    Gender: '',
    Email: '',
    Phone: '',
    InsuredList: [{
        Fio: '',
        LastName: '',
        FirstName: '',
        MiddleName: '',
        BirthDate: '',
        Gender: '',
    }],
    Timestamp: '',
    BeginDate: '',
    EndDate: '',
    AgreePolitics: false,
    AgreeAd: false,
    isLoadingSave: false,
    errorSave: [],
    uid: '',
    price: 0,
    paylink: '',
};

export const StepTwoSlice = createSlice({
    name: 'StepTwoSlice',
    initialState,
    reducers: {
        updateField: (state, action: PayloadAction<{ field: keyof IStepTwo; value: IStepTwo[keyof IStepTwo] }>) => {
            const { field, value } = action.payload;
            state[field] = value as never;
        },
        resetForm: () => initialState,
    },
});

export const { updateField } = StepTwoSlice.actions;
export default StepTwoSlice.reducer;
